module.exports = __webpack_public_path__ + "img/037c52000c1fc5ae3e9d03421cce32b0.png";